import React from 'react';

//import Scss
import './assets/scss/themes.scss';
import './assets/scss/custom-responsive.scss';

//imoprt Route
import Route from './Routes';

// Import Error Boundary for toggle errors
import ToggleErrorBoundary from './Components/Common/ErrorBoundary';

// Import global error handler for toggle issues
import './utils/errorHandler';

// Import AuthProvider for Cognito authentication
import { AuthProvider } from './hooks/useAuth';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
//fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  return (
    <React.Fragment>
      <AuthProvider>
        <ToggleErrorBoundary>
          <Route />
        </ToggleErrorBoundary>
      </AuthProvider>
    </React.Fragment>
  );
}

export default App;
